export function getLayoutObjFromName(layoutName) {
  switch (layoutName) {
    case 'grid':
      return {
        name: 'grid',
        type: 'masonry',
        view: 'grid',
        direction: 'horizontal'
      };
    case 'masonry':
      return {
        name: 'verticalMasonry',
        type: 'masonry',
        view: 'masonry',
        direction: 'vertical'
      };
    case 'horizontalMasonry':
      return {
        name: 'horizontalMasonry',
        type: 'masonry',
        view: 'masonry',
        direction: 'horizontal'
      };
    case 'thumbnails':
      return {
        name: 'thumbnails',
        type: 'thumbnails'
      };
    case 'slider':
      return {
        name: 'slider',
        type: 'slider'
      };
    case 'carousel':
      return {
        name: 'carousel',
        type: 'carousel'
      };
    case 'panoramic':
      return {
        name: 'panoramic',
        type: 'panoramic'
      };
    default:
      return {
        name: 'grid',
        type: 'masonry',
        view: 'grid',
        direction: 'horizontal'
      };
  }
}
